import React, { FC } from 'react';
import classNames from 'classnames';
import { Checkbox } from '@fiverr-private/forms';
import { Container } from '@fiverr-private/layout_components';
import { I18n } from '@fiverr-private/i18n-react';
import { atoms } from '@fiverr-private/theme';
import { SimpleFieldComponentProps } from '../../shared/types';

import { T_FORM_KEY } from '../../utils';
import { fitContent } from '../../shared/styles.ve.css';

const CurrentlyWorkingField: FC<SimpleFieldComponentProps> = ({ defaultValues, register }) => (
    <Checkbox
        id="currentlyWorking"
        defaultChecked={defaultValues?.currentlyWorking}
        {...register('currentlyWorking')}
        className={classNames(
            fitContent,
            atoms({
                marginBottom: '2',
            })
        )}
    >
        <Container userSelect="none">
            <I18n k={`${T_FORM_KEY}.fields.currently_working`} />
        </Container>
    </Checkbox>
);

export default CurrentlyWorkingField;
